import { FreezeIcon, Picture, Rating } from '@ui';
import LeaveCommentForm from '@components/Forms/LeaveCommentForm';
import { starSilver, starGold, emojiThankYou } from '@images';
import ReturnProductForm from '@components/Forms/ReturnProductForm';
import ReviewProductModalStars from './components/ReviewProductModalStars';
import useReviewProductModal from './useReviewProductModal';
import './component.scss';

const badRatingTypesBtns = [
  { title: 'Оформить возврат', type: 'refund' },
  { title: 'Оставить отзыв', type: 'review' }
];

const ReviewProductModalComp = ({
  catalogItem,
  isEditProductReview,
  editText,
  editUploadedFiles,
  editRating,
  objectId,
  availableForRefund,
  currentFormState,
  itemId,
  commentType,
  itemPrice,
  onCloseModal,
  productId,
  setCurrentFormState,
  updateOrdersAfterSubmitReturnForm,
  onEditOrDeleteReviewSubmit,
  isVesovoi,
  orderId
}) => {
  const {
    state: { rating, isMobile, badRatingReviewType },
    functions: {
      changeFormStateAfterSuccessReturnSubmit,
      onBadRatingTypeClickHandler,
      onRateHandler,
      onSuccessfullMessageSend
    },
    misc: { heading, subHeading, isRatingBad }
  } = useReviewProductModal({
    commentType,
    currentFormState,
    isEditProductReview,
    itemId,
    onCloseModal,
    setCurrentFormState,
    updateOrdersAfterSubmitReturnForm,
    editRating
  });

  return (
    <div className='ReviewProductModal'>
      {currentFormState === 0 && (
        <>
          <div className='ReviewProductModal__heading'>{heading}</div>
          <Rating
            initialRating={currentFormState === 0 ? 0 : rating}
            emptySymbol={
              <Picture
                className='ReviewProductModal__star'
                icon={starSilver}
                height='32'
              />
            }
            fullSymbol={
              <Picture
                className='ReviewProductModal__star'
                icon={starGold}
                height='32'
              />
            }
            onChange={onRateHandler}
            size={32}
          />
        </>
      )}
      {currentFormState === 1 && (
        <div className='ReviewProductModal__forms-stage'>
          <div className='ReviewProductModal__forms-stage__title'>
            {subHeading}
          </div>

          {commentType !== 'Comment' && (
            <ReviewProductModalStars rating={rating} />
          )}

          {!!catalogItem && (
            <div className='flex items-center py-2 space-x-5'>
              <div className='relative flex-shrink-0 overflow-hidden rounded-lg w-14 h-14'>
                <img
                  src={catalogItem?.fileItem?.cacheItem?.[0]?.filePath}
                  alt={catalogItem.title}
                  className='object-contain w-full h-full'
                />
                {catalogItem?.war_id === 3 && (
                  <FreezeIcon
                    height={14}
                    className='absolute bottom-0 right-0'
                  />
                )}
              </div>
              <div className='text-sm'>
                <p className='mb-1'>{catalogItem?.title}</p>
                <p className='text-[var(--ultra-dark-grey)]'>
                  арт. {catalogItem?.id}
                </p>
              </div>
            </div>
          )}

          {isRatingBad && availableForRefund && (
            <div className='ReviewProductModal__forms-stage__types-wrapper'>
              {badRatingTypesBtns?.map((item, index) => (
                <div
                  key={index}
                  className={`ReviewProductModal__forms-stage__type${
                    badRatingReviewType === item.type
                      ? ' ReviewProductModal__forms-stage__type--active'
                      : ''
                  }`}
                  onClick={() => onBadRatingTypeClickHandler(item.type)}
                >
                  {item.title}
                </div>
              ))}
            </div>
          )}
          {isRatingBad &&
          badRatingReviewType === 'refund' &&
          availableForRefund ? (
            <ReturnProductForm
              className='ReturnProductForm--modal'
              productId={productId}
              itemId={itemId}
              uniqueId={itemId}
              closeForm={onCloseModal}
              onSuccessfullMessageSend={onSuccessfullMessageSend}
              changeFormStateAfterSuccessReturnSubmit={
                changeFormStateAfterSuccessReturnSubmit
              }
              peoplePurchasedProductPrice={itemPrice}
              isVesovoi={isVesovoi}
            />
          ) : (
            <LeaveCommentForm
              closeForm={onCloseModal}
              isEdit={isEditProductReview}
              editText={editText}
              editUploadedFiles={
                isEditProductReview
                  ? editUploadedFiles?.map(item => ({
                      id: item.id,
                      fileUrl: item.big,
                      isVideo: item.isVideo
                    }))
                  : []
              }
              productId={isEditProductReview ? objectId : productId}
              addCommentInstance='Catalog'
              commentType={commentType}
              rating={rating}
              isMobile={isMobile}
              maximumFilesQuantity={4}
              uniqueId={itemId || objectId}
              onMessageSend={changeFormStateAfterSuccessReturnSubmit}
              onEditOrDeleteReviewSubmit={onEditOrDeleteReviewSubmit}
              orderId={orderId}
            />
          )}
        </div>
      )}
      {currentFormState === 2 && (
        <div className='ReviewProductModal__success-stage'>
          <Picture
            className='ReviewProductModal__success-stage__img'
            icon={emojiThankYou}
            height='70'
          />
          <p className='ReviewProductModal__success-stage__text'>Спасибо!</p>
        </div>
      )}
    </div>
  );
};

export default ReviewProductModalComp;
